const SEARCH_INPUT = '[data-variant-search-input]';
const SEARCH_OPTION = '[data-variant-search-option]';

export function normalizeVariantSearch(value) {
  return String(value || '').trim().toLocaleLowerCase();
}

export function filterVariantOptions(input) {
  const fieldset = input.closest('fieldset');
  if (!fieldset) return [];

  const query = normalizeVariantSearch(input.value);
  const options = Array.from(fieldset.querySelectorAll(SEARCH_OPTION));
  const matches = [];
  let selectedOutsideQuery = null;

  for (const option of options) {
    const matchesQuery = normalizeVariantSearch(option.dataset.variantSearchOption).includes(query);
    const selected = option.querySelector('input[type="radio"]')?.checked === true;
    const keepSelected = selected && !matchesQuery;
    option.hidden = !matchesQuery && !keepSelected;
    if (matchesQuery) matches.push(option);
    else if (keepSelected) selectedOutsideQuery = option;
  }

  const status = fieldset.querySelector('[data-variant-search-status]');
  if (status) {
    const selectedLabel = selectedOutsideQuery?.dataset.variantSearchOption;
    if (selectedLabel) {
      const matchSummary = matches.length
        ? `${matches.length} flavor${matches.length === 1 ? '' : 's'} match your search.`
        : 'No flavors match your search.';
      status.textContent = `${matchSummary} Selected ${selectedLabel} remains shown.`;
    } else {
      status.textContent = matches.length
        ? `${matches.length} flavor${matches.length === 1 ? '' : 's'} shown.`
        : 'No flavors match your search.';
    }
  }

  return selectedOutsideQuery ? [...matches, selectedOutsideQuery] : matches;
}

export function handleVariantSearchInput(event) {
  const input = event.target instanceof Element ? event.target.closest(SEARCH_INPUT) : null;
  if (input instanceof HTMLInputElement) filterVariantOptions(input);
}

export function handleVariantSearchChoiceChange(event) {
  const radio = event.target instanceof Element
    ? event.target.closest(`${SEARCH_OPTION} input[type="radio"]`)
    : null;
  if (!(radio instanceof HTMLInputElement)) return;

  const input = radio.closest('fieldset')?.querySelector(SEARCH_INPUT);
  if (input instanceof HTMLInputElement) filterVariantOptions(input);
}

export function handleVariantSearchKeydown(event) {
  const input = event.target instanceof Element ? event.target.closest(SEARCH_INPUT) : null;
  if (!(input instanceof HTMLInputElement)) return;

  if (event.key === 'Escape' && input.value) {
    event.preventDefault();
    input.value = '';
    filterVariantOptions(input);
    return;
  }

  if (event.key === 'ArrowDown') {
    const firstVisible = filterVariantOptions(input)[0]?.querySelector('input[type="radio"]');
    if (firstVisible instanceof HTMLInputElement) {
      event.preventDefault();
      firstVisible.focus();
    }
  }
}

document.addEventListener('input', handleVariantSearchInput);
document.addEventListener('change', handleVariantSearchChoiceChange);
document.addEventListener('keydown', handleVariantSearchKeydown);
